var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24094_6508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5312 48.9688H1.40625C0.628969 48.9688 0 48.3398 0 47.5625V8.1875C0 7.41022 0.628969 6.78125 1.40625 6.78125H18.2812C19.0585 6.78125 19.6875 7.41022 19.6875 8.1875V40.5312H29.5312C30.3085 40.5312 30.9375 41.1602 30.9375 41.9375V47.5625C30.9375 48.3398 30.3085 48.9688 29.5312 48.9688Z",
    fill: "url(#paint0_linear_24094_6508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 12.2188L35.3438 0.96875H18.4688C17.6812 0.96875 17.0625 1.58741 17.0625 2.375V41.75C17.0625 42.5376 17.6812 43.1562 18.4688 43.1562H46.5938C47.3813 43.1562 48 42.5376 48 41.75V13.625L36.75 12.2188Z",
    fill: "url(#paint1_linear_24094_6508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 13.625H48C48 13.2594 47.8594 12.8938 47.578 12.6407L36.328 1.39072C36.075 1.10938 35.7094 0.96875 35.3438 0.96875V12.2188C35.3438 12.9954 35.9734 13.625 36.75 13.625ZM40.9688 20.6562H24.0938C23.3165 20.6562 22.6875 21.2852 22.6875 22.0625C22.6875 22.8398 23.3165 23.4688 24.0938 23.4688H40.9688C41.746 23.4688 42.375 22.8398 42.375 22.0625C42.375 21.2852 41.746 20.6562 40.9688 20.6562ZM40.9688 29.0938H24.0938C23.3165 29.0938 22.6875 29.7227 22.6875 30.5C22.6875 31.2773 23.3165 31.9062 24.0938 31.9062H40.9688C41.746 31.9062 42.375 31.2773 42.375 30.5C42.375 29.7227 41.746 29.0938 40.9688 29.0938Z",
    fill: "url(#paint2_linear_24094_6508)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24094_6508",
    x1: 0,
    y1: 27.875,
    x2: 30.9375,
    y2: 27.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24094_6508",
    x1: 17.0625,
    y1: 22.0625,
    x2: 48,
    y2: 22.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24094_6508",
    x1: 22.6875,
    y1: 16.4375,
    x2: 48,
    y2: 16.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE2FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24094_6508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.96875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.dc82e617f8777150a1d26e1d24861595.svg";
export { ForwardRef as ReactComponent };